import { withProfile } from 'context/Profile'

const ProfileHeader = ( {
  withProfile: { user }
} ) => {

  return <section className="profile-header">
    <img
      className="photo"
      src={ user.photo_url }
      alt={ user.first_name }
    />

    <span className="first_name">
      { user.first_name }
    </span>

    <span className="username">
      @{ user.username }
    </span>
  </section>
}

export default withProfile( ProfileHeader )
